import { render, staticRenderFns } from "./ViberButton.vue?vue&type=template&id=04e13757&scoped=true&"
import script from "./ViberButton.vue?vue&type=script&lang=js&"
export * from "./ViberButton.vue?vue&type=script&lang=js&"
import style0 from "./ViberButton.vue?vue&type=style&index=0&id=04e13757&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e13757",
  null
  
)

export default component.exports